<template>
	<div class="pt-3">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<v-row>
			<v-col cols="12" class="py-0 py-sm-3">
				<div class="d-flex justify-end">
					<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
						<div class="d-flex">
							<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
							<div class="d-none d-sm-block">Cari</div>
						</div>
					</v-btn>
					<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
				</div>
			</v-col>
		</v-row>
		<div v-if="!loading">
			<v-row v-if="listTransactionRO.length > 0">
				<v-col cols="12" class="pt-0">
					<v-simple-table class="white-row table-vo table-history-bonus">
						<template v-slot:default>
							<thead class="">
								<tr>
									<th class="text-left" width="25%">Tanggal</th>
									<th class="text-left" width="25%">ID Serial</th>
									<th class="text-left" width="25%">Tipe</th>
									<th class="text-right" width="25%">PV</th>
								</tr>
							</thead>
							<tbody class="grey--text text--darken-3">
								<tr v-for="(list, i) in listTransactionRO" :key="i">
									<td class="text-left">{{ list.serial_buy_datetime | tanggaljam }}</td>
									<td class="text-left">{{ list.serial_id }}</td>
									<td class="text-left">{{ list.serial_serial_type_label }}</td>
									<td class="text-right">{{ list.serial_pv | toNumber }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="listTransactionRO.length == 0">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada list transaksi yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div v-if="listTransactionRO.length > 0">
				<v-row justify="end">
					<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
						<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="transactionROPagination.total_page" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
						<div class=" font-size-10">Menampilkan {{ transactionROPagination.total_display }} data dari total {{ transactionROPagination.total_data }} data</div>
					</v-col>
					<v-col cols="4" sm="2" md="1">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
		<div class="mt-4" v-if="loading">
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';

export default {
	components: {
		ModalSearch
	},
	data() {
		return {
			loading: false,
			waitingReport: true,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('transactionSerial', ['listTransactionRO', 'transactionROPagination']),
	},
	methods: {
		...mapActions('transactionSerial', ['getTransactionRO']),

		getData() {
			this.loading = true
			this.getTransactionRO(this.queryString({sort: 'serial_buy_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalSearch.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.id.value)
				this.params.push(data.id)
			if(data.date.value)
				this.params.push(data.date)
			this.getTransactionRO(this.queryString({sort: 'serial_buy_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Laporan Transaksi RO`)
		this.getData()
	}
};
</script>